import { FC, useEffect } from "react";
import useBackendLanguage from "@hooks/useBackendLanguage";
import { useTranslation } from "react-i18next";
import PrivateRoutes from "@js/PrivateRoutes";
import classNames from "@utils/cx";
import { getDefaultStore, useAtomValue } from "@store";
import { disableUserSelectionAtom } from "@js/store/appAtoms";
import { selectedPhotoAtom } from "@js/store/orderPageAtoms";

const App: FC = () => {
  const { t } = useTranslation();
  const disableUserSelection = useAtomValue(disableUserSelectionAtom);

  useBackendLanguage();

  // Release the object URL of the previously selected camera photo whenever it
  // is replaced or cleared. URL.createObjectURL keeps the full image Blob alive
  // for the lifetime of the document; without revoking it, every photo a user
  // takes leaks several MB in this never-reloaded SPA. Subscribing at the store
  // level (instead of via useAtomValue) avoids re-rendering the route subtree.
  useEffect(() => {
    const store = getDefaultStore();
    let previousUrl = store.get(selectedPhotoAtom)?.url ?? null;

    return store.sub(selectedPhotoAtom, () => {
      const nextUrl = store.get(selectedPhotoAtom)?.url ?? null;
      if (
        previousUrl &&
        previousUrl !== nextUrl &&
        previousUrl.startsWith("blob:")
      ) {
        URL.revokeObjectURL(previousUrl);
      }
      previousUrl = nextUrl;
    });
  }, []);

  return (
    <div
      className={classNames("app", {
        "app--disableUserSelection": disableUserSelection,
      })}
    >
      <meta name="description" content={t("meta.description")} />
      <PrivateRoutes />
      <div className="modals" />
    </div>
  );
};

export default App;
